import { render } from "./ProjectsPage.vue?vue&type=template&id=78be1e14&scoped=true&ts=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectsPage.vue?vue&type=script&lang=ts"

import "./ProjectsPage.vue?vue&type=style&index=0&id=78be1e14&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78be1e14"]])

export default __exports__